import { Component } from '@angular/core';
import { CannabisInvitationService } from '../../services/cannabis-invitation.service';

@Component({
  selector: 'app-cannabis-invitation-banner',
  templateUrl: './cannabis-invitation-banner.component.html',
  styleUrls: ['./cannabis-invitation-banner.component.scss']
})
export class CannabisInvitationBannerComponent {

  /** Solo oculta el banner hasta la próxima recarga; no se persiste */
  bannerClosedThisView = false;

  constructor(public invitationService: CannabisInvitationService) {}

  get visible(): boolean {
    return this.invitationService.isInvitationActive() && !this.bannerClosedThisView;
  }

  close(): void {
    this.bannerClosedThisView = true;
  }
}
